import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (<div className='min-h-screen flex items-center justify-center'>
        <div className='animate-spin rounded-full h-32 w-32 border-b-2 border-navy'></div>
      </div>);
    }
    if (!user) {
        return <Navigate to='/admin/login' replace/>;
    }
    return <>{children}</>;
}
